import React from 'react'
import { UnderwritingOffer } from '_gql'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import CreditLineOfferPage from '@sputnik/pages/PostApplicationPages/CreditLineOffersPage/CreditLineOfferPage'
import { URL } from '@sputnik/resources/constants'

const VariableCreditLineOfferPage = () => {
  const { formatMessage } = useIntl()

  return (
    <CreditLineOfferPage
      bulletPoints={[
        <FormattedMessage
          key='variable-credit-limit'
          defaultMessage='Your credit limit may fluctuate based on the cash balance in your connected bank accounts.'
          id='sputnik.VariableCreditLineOfferPage__fxcTnF'
        />,
        <FormattedMessage
          key='request-credit-limit-increase'
          defaultMessage="We'll use a secure digital banking connection to review your account balances and determine any changes to your credit limit."
          id='sputnik.VariableCreditLineOfferPage__CP/8gQ'
        />,
        <FormattedMessage
          key='balance-due'
          defaultMessage='Your balance is due in full at the end of each billing cycle.'
          id='sputnik.VariableCreditLineOfferPage__8LBAFn'
        />,
      ]}
      learnMoreLink={URL.VARIABLE_LINE_OFFER_LEARN_MORE_LINK}
      marketingImage={{
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-variable-line-offer-content.png',
        alt: formatMessage({
          defaultMessage: 'woman in the woods, looking up at the trees',
          id: 'sputnik.VariableCreditLineOfferPage__hS1Obb',
        }),
      }}
      title={
        <FormattedMessage
          defaultMessage='Variable credit line offer'
          id='sputnik.VariableCreditLineOfferPage__zsAeQB'
        />
      }
      underwritingOfferType={UnderwritingOffer.VARIABLE_LINE}
    />
  )
}

export default VariableCreditLineOfferPage
